export default __webpack_public_path__ + "static/media/capricorn.4d575159.png";